











































































import {defineComponent, onBeforeUnmount, onMounted, PropType} from "@vue/composition-api"
import PortalTimelineItemComponent from "@/apps/PortalTimelineWidget/components/PortalTimelineItemComponent.vue";
import {IPortalTimelineItem, IPortalTimelineWidgetLabels} from "@/apps/PortalTimelineWidget/models/portal-timeline-widget-state";
import {useActions, useMutations, useState} from "vuex-composition-helpers";
import PortalAccordion from "@/apps/PortalTimelineWidget/components/accordion/PortalAccordion.vue";

export default defineComponent({
    name: "PortalTimelineWidget",
    components: {
        PortalAccordion,
        PortalTimelineItemComponent
    },
    props: {
        title: {type: String, required: true},
        items: {type: Array as PropType<IPortalTimelineItem[]>, required: true},
        labels: {type: Object as PropType<IPortalTimelineWidgetLabels>, required: true}
    },
    setup: (props) => {
        const {init} = useActions(['init'])
        const {selectedItem, currentlyOpenTopic} = useState(['selectedItem', 'currentlyOpenTopic'])
        const {setSelectedItem, setSelectedItemIndex} = useMutations(['setSelectedItem', 'setSelectedItemIndex'])

        onMounted(async () => {
            await init(props)

            if (localStorage.selectedItemIndex) {
                setSelectedItem(localStorage.selectedItemIndex)
                setSelectedItemIndex(localStorage.selectedItemIndex)
            }

            if (localStorage.portalScrollPosition) {
                window.scrollTo(0, localStorage.portalScrollPosition)
            }

            // Timeline fade
            const timeline = document.querySelector('.timeline-white-stroke');
            if (timeline) {
                timeline.addEventListener('scroll', (e) => {
                    setFadeClasses(timeline);
                });

                setFadeClasses(timeline);
            }

            window.addEventListener('beforeunload', beforeUnloadHandler)
        })

        onBeforeUnmount(() => {
            window.removeEventListener('beforeunload', beforeUnloadHandler)
        })

        function beforeUnloadHandler() {
            localStorage.portalScrollPosition = window.scrollY
        }

        function setFadeClasses(el: Element) {
            // Adjust scrollLeft to ensure it's within permissible range
            const adjustedScrollLeft = Math.max(0, Math.min(el.scrollLeft, el.scrollWidth - el.clientWidth));

            const isScrolledToRight = el.scrollWidth <= el.clientWidth + adjustedScrollLeft;
            const isScrolledToLeft = isScrolledToRight ? false : adjustedScrollLeft === 0;

            el.classList.toggle('is-right-overflowing', !isScrolledToRight);
            el.classList.toggle('is-left-overflowing', !isScrolledToLeft);
        }

        return {
            selectedItem,
            currentlyOpenTopic
        }
    }
})
